var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-overlay",style:({
    backgroundColor: _vm.backgroundColor,
    borderRadius: _vm.borderRadius,
  })},[_c('b-spinner',{directives:[{name:"page-color",rawName:"v-page-color"}],attrs:{"label":"Loading..."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }